import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/sad-tear': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM256 304c38.1 0 74 16.8 98.5 46.1 8.5 10.2 7.1 25.3-3.1 33.8-10.6 8.8-25.7 6.7-33.8-3.1-15.3-18.3-37.8-28.8-61.6-28.8-13.2 0-24-10.8-24-24s10.8-24 24-24zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 176c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM162.4 274.8c2.8-3.7 8.4-3.7 11.2 0 11.4 15.3 36.4 50.6 36.4 68.1 0 22.7-18.8 41.1-42 41.1s-42-18.4-42-41.1c0-17.5 25-52.8 36.4-68.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/sad-tear.js
// module id = 1810
// module chunks = 0